module.exports = __webpack_public_path__ + "img/product2_11B984_term.29d6eae4.png";